import { Drawer } from '@mantine/core';

import {
  DashboardWidget,
  isDataWidget,
  isFilesSearchWidget,
  isFilesWidget,
  isIframeWidget,
  isMultiStreamWidget,
  isStreamWidget,
  WidgetType,
} from 'types/dashboard_widget';

import { DataForm } from 'dashboards/components/Form/DataForm';
import { ExternalLink } from 'components/ExternalLink/ExternalLink';
import { FilesForm } from 'dashboards/components/Form/FilesForm';
import { FilesSearchForm } from 'dashboards/components/Form/FilesSearchForm';
import { Heading } from 'components/Heading/Heading';
import { IframeForm } from 'dashboards/components/Form/IframeForm';
import { MultiStreamForm } from 'dashboards/components/Form/MultiStreamForm';
import { StreamForm } from 'dashboards/components/Form/StreamForm';

type AddFormProps = {
  type: WidgetType;
  dashboardId: string;
  widget?: never;
};

type EditFormProps = {
  widget: DashboardWidget;
  dashboardId: string;
  type?: never;
};

type WidgetFormProps = AddFormProps | EditFormProps;

export function WidgetForm({ type, widget, ...props }: WidgetFormProps) {
  return (
    <>
      <Drawer.Header className="flex gap-2">
        <Heading level="3">{`${widget ? 'Edit' : 'Add'} dashboard widget`}</Heading>
        <ExternalLink href="https://docs.lumeo.com/docs/dashboard">
          Dashboard docs
        </ExternalLink>
        <Drawer.CloseButton />
      </Drawer.Header>

      <Drawer.Body>
        {widget ? (
          <>
            {isDataWidget(widget) && <DataForm {...props} widget={widget} />}
            {isFilesWidget(widget) && <FilesForm {...props} widget={widget} />}
            {isFilesSearchWidget(widget) && (
              <FilesSearchForm {...props} widget={widget} />
            )}
            {isIframeWidget(widget) && (
              <IframeForm {...props} widget={widget} />
            )}
            {isStreamWidget(widget) && (
              <StreamForm {...props} widget={widget} />
            )}
            {isMultiStreamWidget(widget) && (
              <MultiStreamForm {...props} widget={widget} />
            )}
          </>
        ) : (
          <>
            {type === 'data' && <DataForm {...props} />}
            {type === 'files' && <FilesForm {...props} />}
            {type === 'files-search' && <FilesSearchForm {...props} />}
            {type === 'iframe' && <IframeForm {...props} />}
            {type === 'multistream' && <MultiStreamForm {...props} />}
            {type === 'stream' && <StreamForm {...props} />}
          </>
        )}
      </Drawer.Body>
    </>
  );
}
